export const AllIncidentsConfig = [
  { label: "Incident ID", key: "incidentId" },
  { label: "Incident Name", key: "incidentName" },
  { label: "Incident Date & Time", key: "incidentDateAndTime" },
  { label: "Incident Description", key: "description" },
  { label: "Branch and Location", key: "branchName" },
  { label: "Source", key: "sourceName" },
  { label: "Affected Services", key: "affectedServices" },
  { label: "Severity", key: "severityLevel" },
  { label: "SLA Target", key: "slaTarget" },
  { label: "Status", key: "event_status" },
  { label: "Reported By", key: "reporterName" },
  { label: "Reported Date &Time", key: "reportedDate" },
  { label: "Created Date &Time", key: "created_on" },
];
